import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import { COUNTRY_CODES } from '../../constants';
import LatLngPropType from '../../prop-types/latlng';
import { distanceFormatter } from '../../../lib/utils';
import measureDistance from '../../../lib/utils/measureDistance';
import styles from './StationDistance.module.css';

const cx = classnames.bind(styles);

export default function StationDistance({ from, to, country }) {
  const distance = useMemo(() => (
    measureDistance(to.lat, to.lng, from.lat, from.lng)
  ), [to.lat, to.lng, from.lat, from.lng]);

  const displayDistance = useMemo(() => (
    distanceFormatter(distance, country)
  ), [distance, country]);

  return (
    <div className={cx('distanceContainer')}>
      {displayDistance}
    </div>
  );
}

StationDistance.propTypes = {
  from: LatLngPropType,
  to: LatLngPropType,
  country: PropTypes.oneOf(Object.values(COUNTRY_CODES)),
};

StationDistance.defaultProps = {
  from: undefined,
  to: undefined,
  country: COUNTRY_CODES.USA,
};
